import { Select } from "components/ui/select/Select"
import { OTHER_TOP_LEVEL_CATEGORY } from "../../furniture.constants"
import type { DefaultOptionType } from "antd/es/select"
import style from "./CategoriesSection.module.scss"

const { section, sectionTitle, field, labelRow, label, requiredMark } = style

type CategoryValue = string | number | null

type Props = {
	topLevelValue: CategoryValue
	topLevelOptions: DefaultOptionType[]
	onTopLevelChange: (value: CategoryValue) => void
	superValue: CategoryValue
	superOptions: DefaultOptionType[]
	onSuperChange: (value: CategoryValue) => void
	modelCategoryValue: CategoryValue
	modelCategoryOptions: DefaultOptionType[]
	onModelCategoryChange: (value: CategoryValue) => void
}

export const CategoriesSection = ({
	topLevelValue,
	topLevelOptions,
	onTopLevelChange,
	superValue,
	superOptions,
	onSuperChange,
	modelCategoryValue,
	modelCategoryOptions,
	onModelCategoryChange,
}: Props) => {
	const isOther = topLevelValue === OTHER_TOP_LEVEL_CATEGORY
	const showSuper = topLevelValue !== null && !isOther
	const showObject = topLevelValue !== null && !isOther && superValue !== null

	return (
		<div className={section}>
			<p className={sectionTitle}>Categories</p>
			<div className={field}>
				<div className={labelRow}>
					<span className={label}>Top level category</span>
					<span className={requiredMark}>*</span>
				</div>
				<Select
					variant="outlined"
					options={topLevelOptions}
					value={topLevelValue as string | number | null | undefined}
					onChange={(next) => onTopLevelChange(next as CategoryValue)}
					placeholder="Select category"
					showSearch
					optionFilterProp="label"
					renderInPlace
				/>
			</div>

			{showSuper ? (
				<div className={field}>
					<div className={labelRow}>
						<span className={label}>Super category</span>
						<span className={requiredMark}>*</span>
					</div>
					<Select
						variant="outlined"
						options={superOptions}
						value={superValue as string | number | null | undefined}
						onChange={(next) => onSuperChange(next as CategoryValue)}
						placeholder="Select super category"
						showSearch
						optionFilterProp="label"
						renderInPlace
					/>
				</div>
			) : null}

			{showObject ? (
				<div className={field}>
					<div className={labelRow}>
						<span className={label}>Object</span>
						<span className={requiredMark}>*</span>
					</div>
					<Select
						variant="outlined"
						options={modelCategoryOptions}
						value={modelCategoryValue as string | number | null | undefined}
						onChange={(next) => onModelCategoryChange(next as CategoryValue)}
						placeholder="Select object"
						showSearch
						optionFilterProp="label"
						renderInPlace
					/>
				</div>
			) : null}
		</div>
	)
}
